import { cn } from '@/shadcn/lib/utils';

/**
 * @function
 * @param {object} props
 * @param {string} props.children
 * @param {string} [props.maxWidth] Either we set a maxWidth in the parent node or
 * we pass it as a prop
 */

type Props = React.PropsWithChildren<{
  maxWidth?: string;
  className?: string;
}>;

export const Ellipsis = ({ children, className }: Props) => (
  <div className={cn('truncate', className)}>{children}</div>
);
